import ZurichWhite from "../assets/logos/zurich_white.png";
import TerraWindWhite from "../assets/logos/terrawind_white.png";
import RivadaviaLogo from "../assets/logos/rivadavia_logo.svg";

export const companiesDict = {
    "Sancor": {
        id: 1,
        logo: "https://i.imgur.com/F55GPdm.png", //TODO: use right link
        products: [
            {label: "AUTOMOTOR", value: "vehiculo"},
            {label: "MICROSEGUROS", value: "microseguros"},
            {label: "HOGAR", value: "hogar"}
        ],
        formasDePago: [{label: 'Tarjeta de crédito', value: 'TC'}, {label: 'Débito por CBU', value: 'CBU'}],
        codigoFormasDePago: {TC: '2', CBU: '4'},
        idsTarjeta: [
            {value: '1', label: 'Cabal'},
            {value: '5', label: 'Visa'},
            {value: '7', label: 'Favacard'},
            {value: '9', label: 'American Express'},
            {value: '12', label: 'Naranja'},
            {value: '16', label: 'Diners Club'},
            {value: '18', label: 'Naranja Visa'},
            {value: '20', label: 'Cordobesa Mastercard'},
            {value: '23', label: 'TDF - Tierra del Fuego'},
            {value: '45', label: 'Mastercard Nueva'},
            {value: '57', label: 'ELEBAR'},
            {value: '70', label: 'Cencosud Mastercard'},
        ],
        equipoGncId: '1'
    },
    "RUS": {
        id: 2,
        logo: "https://i.imgur.com/WUaf6QD.png", //TODO: use right link
        products: [{label: "AUTOMOTOR", value: "vehiculo"}],
        formasDePago: [{label: 'Tarjeta de crédito', value: 'TC'}, {label: 'Débito por CBU', value: 'CBU'}],
        codigoFormasDePago: {TC: '2', CBU: '4'},
        idsTarjeta: [
            {value: '1', label: 'Visa'},
            {value: '3', label: 'Mastercard'},
            {value: '6', label: 'Naranja'},
            {value: '7', label: 'Cabal'},
            {value: '11', label: 'American Express'},
            {value: '14', label: 'Kadicard'},
            {value: '16', label: 'Nativa MasterCard'},
            {value: '18', label: 'CMR Falabella'},
            {value: '19', label: 'Tarjeta Plata'},
            {value: '22', label: 'Favacard'},
        ],
        equipoGncId: '1'
    },
    "Zurich": {
        id: 3,
        logo: ZurichWhite,
        products: [{label: "AUTOMOTOR", value: "vehiculo"}],
        formasDePago: [{label: 'Tarjeta de crédito', value: 'TC'}, {label: 'Débito por CBU', value: 'CBU'}],
        codigoFormasDePago: {TC: '4', CBU: '7'},
        idsTarjeta: [
            {value: '30654364229-2', label: 'Cabal'},
            {value: '30684195707-2', label: 'Nevada'},
            {value: '30598910045-2', label: 'Visa'},
            {value: '30574816870-2', label: 'Amex'},
            {value: '30536209383-2', label: 'KADICARD Pesos'},
            {value: '30579836268-2', label: 'Diners'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
            {value: '30522211563-2', label: 'Argen/Master'},
            {value: '30681424721-2', label: 'MIRA Pesos'},
            {value: '30685376349-2', label: 'Naranja'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
        ],
        equipoGncId: '3'
    },
    "TerraWind": {
        id: 4,
        logo: TerraWindWhite,
        products: [{label: "ASISTENCIA AL VIAJERO", value: "asistencia_viajero", key: "asistenciaViajero"}],
        razonSocial: "Terrawind",



        descuento: "prima",
        codigoFormasDePago: {TC: '4', CBU: '7', EF: '5'},
        idsTarjeta: [
            {value: '30654364229-2', label: 'Cabal'},
            {value: '30684195707-2', label: 'Nevada'},
            {value: '30598910045-2', label: 'Visa'},
            {value: '30574816870-2', label: 'Amex'},
            {value: '30536209383-2', label: 'KADICARD Pesos'},
            {value: '30579836268-2', label: 'Diners'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
            {value: '30522211563-2', label: 'Argen/Master'},
            {value: '30681424721-2', label: 'MIRA Pesos'},
            {value: '30685376349-2', label: 'Naranja'},
            {value: '30619540146-2', label: 'CREDIMAS Pesos'},
        ],
        bienesAdicionales: [],
        emissionStatus: {Success: "approved", Pending: "pending", Cancel: "rejected"},
        opcionesRolesExtra: [
            {value: '2', label: 'Asegurado'},
            {value: '1', label: 'Tomador'},
            {value: '3', label: 'Acreedor'},
        ],
        rolPrincipal: {value: '2', label: 'Asegurado'}
    },
    "Rivadavia": {
        id: 7,
        logo: RivadaviaLogo,
        products: [
            {label: "AUTOMOTOR", value: "vehiculo", key: "automotor", hasDeclaracionJurada: true},
            {label: "MOTOVEHÍCULO", value: "motovehiculo", key: "motovehiculo", hasDeclaracionJurada: true}
        ],
        codigoFormasDePago: {TC: 'TARJETA_CREDITO', CBU: 'CBU', EF: 'PAGO_FACIL'},
        formasDePago: {
            automotor: ["TC", "CBU", "EF"],
            motovehiculo: ["TC", "CBU", "EF"],
        },
        idsTarjeta: [
            {value: 'ARGENCARD_MASTERCARD', label: 'Argencard/Mastercard'},
            {value: 'VISA', label: 'Visa'},
            {value: 'DINERS', label: 'Diners'},
            {value: 'CABAL', label: 'Cabal'},
            {value: 'CARTA_AUSTRAL', label: 'Carta Austral'},
            {value: 'FAVACARD', label: 'Favacard'},
            {value: 'AMERICAN_EXPRESS', label: 'American Express'},
            {value: 'AUTOMATICA', label: 'Automatica'},
            {value: 'NARANJA', label: 'Naranja'},
            {value: 'SUCREDITO', label: 'Sucredito'},
            {value: 'NATIVA', label: 'Nativa'},
            {value: 'COOPEPLUS', label: 'CoopePlus'},
            {value: 'DATA_2000', label: 'Data 2000'}
        ],
        equipoGncId: "13",
    },
}

export const companiesIdDict = {
    1: "Sancor",
    2: "RUS",
    3: "Zurich",
    4: "Terrawind",
    7: "Rivadavia"
}
